import {Button} from "@/components/ui/button.tsx";

export default function NotFoundPage() {
    return (
        <div className={"flex flex-col items-center justify-center gap-4 w-screen h-screen"}>
            <p className={"text-3xl"}>A keresett oldal nem található!</p>
            <Button asChild>
                <a href={"/"}>
                Újratöltés
                </a>
            </Button>
        </div>
    )
}